import { get, isEmpty as isempty } from 'lodash-es';

export const selectSearchValue = (state) => get(state, 'searchValue');
export const selectScaleId = (state) => get(state, 'scaleId');
export const selectPrinterId = (state) => get(state, 'printerId');
export const selectWorkstationId = (state) => get(state, 'workstationId');
export const selectOrderSearchResult = (state) =>
  !isempty(get(state, 'orderNumberSearch')) ? get(state, 'orderNumberSearch') : { searchValue: '', orders: [] };
export const selectJobId = (state) => get(state, 'jobId');
export const selectFulfillmentPlanId = (state) => get(state, 'fulfillmentPlanId');
export const selectStatusIndicator = (state) => get(state, 'statusIndicator');
export const selectErrorMessages = (state) => get(state, 'errors');
export const selectMode = (state) => get(state, 'mode');
export const selectIsHeaderFocused = (state) => get(state, 'isHeaderFocused');
export const selectQueue = (state) => get(state, 'queue');
